import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { VERSION_FIELD_DESCRIPTOR } from './_versionField.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { TECHNICAL_SHEET, TechnicalSheetKindValues, } from '../types/technical-sheet.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for Technical Sheet (Ficha técnica) entity.
 * Stored in 'org/{orgId}/technical-sheet'.
 */
export const technicalSheetDescriptor = {
    name: TECHNICAL_SHEET,
    label: 'Ficha técnica',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/technical-sheet',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Ficha técnica com produto e cor vinculados',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        // NoCache: entidade versionada (spec 0045) — getById em cache devolve versão velha e anula a detecção de conflito.
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique technical sheet identifier',
        },
        {
            name: 'code',
            example: 'FT-8842-VM01',
            label: 'Código',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.CODE,
            description: 'Technical sheet code',
        },
        {
            name: 'description',
            example: 'Ficha — Malha PV 30/1 Vermelho Carmim',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Technical sheet description',
        },
        {
            name: 'productId',
            label: 'Produto vinculado',
            type: 'string',
            required: false,
            description: 'Reference to the linked product',
        },
        {
            name: 'colorId',
            label: 'Cor vinculada',
            type: 'string',
            required: false,
            description: 'Reference to the linked color',
        },
        {
            name: 'kind',
            example: 'guided',
            label: 'Tipo',
            type: 'enum',
            required: false,
            enumValues: [...TechnicalSheetKindValues],
            description: "Absent/null = ordinary sheet; 'guided' = facilitated module; 'template' = model sheet (no product)",
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
        VERSION_FIELD_DESCRIPTOR,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'productId',
            targetEntity: 'Product',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Produto vinculado à ficha técnica',
        },
        {
            fieldName: 'colorId',
            targetEntity: 'Color',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Cor vinculada à ficha técnica',
        },
        {
            fieldName: 'id',
            targetEntity: 'TechnicalSheetRoute',
            relationship: 'one-to-many',
            description: 'Roteiros da ficha técnica',
        },
        {
            fieldName: 'id',
            targetEntity: 'TechnicalSheetMaterial',
            relationship: 'one-to-many',
            description: 'Materiais da ficha técnica',
        },
    ],
};
//# sourceMappingURL=technical-sheet.descriptor.js.map